import {Observable} from 'rxjs';
import {jobHunterAPI, RestQueryParams} from 'jobhunter-common-web';

export function getOfferViewAPI(offerId: string | null): Observable<any> {
    const headers = undefined;
    return jobHunterAPI.get(`api/offers/${offerId}/as_candidate`, new RestQueryParams(), headers);
}
